import script from "./DocumentUploadModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./DocumentUploadModal.vue?vue&type=script&setup=true&lang=ts"

import "./DocumentUploadModal.vue?vue&type=style&index=0&id=40c5511e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40c5511e"]])

export default __exports__